import AnalyticsService from '../../../services/AnalyticsService';
import { PlayFormat } from '../../../services/AnalyticsService/Types';
import { PlayerEvents } from '../playbackTypes';

const debug = require('debug')('tca:kit:components:KitPlayer:utils:analytics:');

/**
 * https://subsplash.atlassian.net/wiki/spaces/PLAT/pages/505446585/Media+Analytics+Play+Tracking#Plays
 *
 * sendPlays requires at least playId, appKey, url, and format to succeed
 */
export const sendPlays = ({
  appKey,
  format,
  playId,
  sapId,
  url,
}: {
  appKey: string;
  format: PlayFormat;
  playId: string;
  sapId?: string;
  url: string;
}): void => {
  if (!playId || !appKey || !url || !format) {
    debug('sendPlays: insufficient data', {
      appKey,
      format,
      playId,
      url,
    });

    return;
  }

  AnalyticsService.sendEvent({
    type: 'plays',
    appKey: appKey,
    data: {
      format,
      sapId: sapId,
      url: url,
      playId: playId,
    },
  });
};

/**
 * https://subsplash.atlassian.net/wiki/spaces/PLAT/pages/505446585/Media+Analytics+Play+Tracking#Play-Events
 *
 * sendPlayEvent requires at least playId, event, and appKey to succeed
 */
export const sendPlayEvent = ({
  appKey,
  data,
  event,
  format,
  playId,
  position = -1,
}: {
  appKey: string;
  data?: string;
  event: PlayerEvents;
  format?: PlayFormat;
  playId: string;
  position?: number;
}): void => {
  if (!playId || !appKey || !event) {
    debug('sendPlayEvent: insufficient data', {
      appKey,
      event,
      playId,
    });

    return;
  }

  AnalyticsService.sendEvent({
    type: 'play-events',
    appKey: appKey,
    data: {
      format: format,
      event,
      position,
      playId: playId,
      data,
    },
  });
};

/**
 * https://subsplash.atlassian.net/wiki/spaces/PLAT/pages/505446585/Media+Analytics+Play+Tracking#Play-Positions
 *
 * sendPlayPositions requires at least playId, appKey, and segmentLog to succeed
 */
export const sendPlayPositions = ({
  appKey,
  format,
  playId,
  segmentLength = 30000, // 30 seconds
  segmentLog,
}: {
  appKey: string;
  format?: PlayFormat;
  playId: string;
  segmentLength?: number;
  segmentLog: number[];
}): void => {
  if (!playId || !appKey || !segmentLog) {
    debug('sendPlayPosition: insufficient data', {
      appKey,
      playId,
      segmentLog,
    });

    return;
  }

  AnalyticsService.sendEvent({
    type: 'play-positions',
    appKey: appKey,
    data: {
      format,
      playId,
      segmentLength,
      segmentLog,
    },
  });
};
